import React from 'react';
import Header from '../Core/Header';
import Footer from '../Core/Footer';
import { Container } from 'reactstrap';

// TODO: import '../../../common/styles/general.scss';

/**
 * This layout handles all user pages. 
 */
class PlatformLayout extends React.Component {

    render() {
        return (
            <div className='app'>
                
                <Header/>

                <div className='app-body'>

                    <main className='main'>
                        <Container fluid>
                            {this.props.children}
                        </Container>
                    </main>
                </div>

                <Footer/>

            </div>
        );
    }
}

export default PlatformLayout;